import { useState, useEffect } from "react";
export const useRenderedOnClient = () => {
  const [isRenderedOnClient, setIsRenderedOnClient] = useState(false);

  useEffect(() => setIsRenderedOnClient(true), []);

  return isRenderedOnClient;
};
